<script>
  export let title = undefined;
  export let vertical = false;
  export let compact = false;
</script>

{#if title}
  <h2 class:vertical class:compact class={$$props.style} on:click>{title}</h2>
{:else}
  <h2 class:vertical class:compact class={$$props.style} on:click>
    <slot />
  </h2>
{/if}

<style>
  h2 {
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    font-weight: 700;
    color: var(--blue-color);
    transform-origin: 0 0;
    transition: all ease-in-out 0.5s;
  }

  .reverse {
    color: white;
  }

  .secondary {
    color: var(--marine-color);
  }

  .vertical {
    white-space: nowrap;
    transform-origin: 0 0;
    transform: rotate(90deg) translateY(-6px);
  }

  .compact {
    margin: 0;
    letter-spacing: 1px;
  }
</style>
